var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasTags
    ? _c("project-explorer", {
        attrs: {
          tags: _vm.projectExplorerTags,
          source: _vm.source,
          "default-tag-key": _vm.defaultTagKey,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }